import styled from "styled-components";
// styled(({ ...rest }) => <NavLink {...rest} />
// export const PurchaseButton = styled(({ ...rest }) => <NavLink {...rest} />)`
//     margin: ${props => (props.margin ? props.margin : "1rem auto")};
//     width: 100%;
//   }
//   p {
//     line-height: 37px;
//     width: 229px;
//     height: 37px;
//     background-color: #8dc323;
//     border-radius: 5px;
//     // float: left;
//     margin-left: 20px;
//     transition: 0.5s;
//     cursor: pointer;
//     box-sizing: border-box;
//     @media screen and (max-width: 600px) {
//       float: unset;
//       width: 80%;
//   }
// `;
// 수한 디자인 고르기에서 결제 가능하게 변경중
//[명수] 디자인 변경에 따른 width/margin-left 값 변경
export const PurchaseButton = styled.div`
width: 40%;
margin-right: 5px;
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  
  p {
    line-height: 37px;
    font-size: 15px;
    font-weight: 600;
    color: #252525 !important;
    height: 37px;
    border: solid 1px #252525;
    border-radius: 3px;
    transition: 0.5s;
    cursor: pointer;
    box-sizing: border-box;
    &:hover{
      background-color: #f0f0f0;
    }
    @media screen and (max-width: 600px) {
      float: unset;
      width: 97%;
      margin: 0;
  }
}
`;

export const NormalButton = styled.div`
  width: 100%;
  height: 37px;
  font-weight: 600;
  background-color: #252525;
  border-radius: 3px;
  float: left;
  transition: 0.5s;
  cursor: pointer;
  box-sizing: border-box;
  &:hover{
      background : #494949;
    }
  @media screen and (max-width: 600px) {
    float: unset;
    width: 80%;
    margin: ${props => (props.margin ? props.margin : "1rem auto")};
    flex : 1;
  }
  p {
    line-height: 37px;
    
  }
`;

//[명수] 디자인 변경에 따른 width/margin-left 값 변경
export const FreeCouponButton = styled.div`
  width: 60%;
  height: 37px;
  font-weight: 600;
  margin-left: 5px;
  background-color: #252525;
  border-radius: 3px;
  display : flex;
  transition: 0.5s;
  cursor: pointer;
  justify-content : center;
  box-sizing: border-box;
  &:hover{
    background: #494949;
  }
  @media screen and (max-width: 600px) {
    float: unset;
    width: 80%;
    margin: ${props => (props.margin ? props.margin : "1rem auto")};
  }
  p {
    line-height: 37px;
  }
`;

export const FreeEventButton = styled.div`
  width: 260px;
  height: 37px;
  font-weight: 600;
  background-color: #699be2;
  border-radius: 5px;
  float: left;
  margin-left: 20px;
  transition: 0.5s;
  cursor: pointer;
  box-sizing: border-box;
  &:hover{
      background : #5781bd;
    }
  @media screen and (max-width: 600px) {
    float: unset;
    width: 80%;
    margin: ${props => (props.margin ? props.margin : "1rem auto")};
    flex : 1;
  }
  p {
    line-height: 37px;

  }
`;